// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2y8WD","boxTitle":"Qualiphy_boxTitle__3enre","box":"Qualiphy_box__1K3Cd","toggleWrap":"Qualiphy_toggleWrap__2fjre"};